import type { SieogDocumentArchive } from "@/types/sieog"
import { API_ROOT, HttpClient } from "@/api/httpClient"
import { file2Base64 } from "@/utils"

export default {
	list(patientId: number) {
		return HttpClient.get<SieogDocumentArchive[]>(
			`${API_ROOT}/medical-centers/patients/${patientId}/sieog-documents`
		)
	},
	generate(patientId: number, slug: string) {
		return HttpClient.post<Blob>(
			`${API_ROOT}/medical-centers/patients/${patientId}/sieog-documents`,
			{
				slug
			},
			{
				responseType: "blob"
			}
		)
	},
	upload(patientId: number, slug: string, file: File) {
		return HttpClient.postForm(`${API_ROOT}/medical-centers/patients/${patientId}/sieog-documents/upload`, {
			slug,
			file
		})
	},
	send(patientId: number, slug: string) {
		return HttpClient.post(`${API_ROOT}/medical-centers/patients/${patientId}/sieog-documents/send-template`, {
			slug
		})
	},
	delete(patientId: number, fileId: number) {
		return HttpClient.delete(`${API_ROOT}/medical-centers/patients/${patientId}/sieog-documents/${fileId}`)
	},
	getSieogDocumentBinary(url: string) {
		return HttpClient.get<Blob>(url, {
			responseType: "blob"
		}).then(res => file2Base64(res.data))
	}
}
